import axios from './axios';
import SETTINGS from '../settings'
export default {
    getAchievements(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/achievement`, { params }).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    }
}